import validator from "validator";

export function createExamFormValidator(values) {
  const errors: any = {};
  if (!values.name) {
    errors.name = "Name field is required";
  }

  return errors;
}

export function passedExamsFormValidator(values) {
  const errors: any = {};
  if (values.exams) {
    errors.exams = [];
    values.exams.forEach((item, index) => {
      errors.exams[index] = {};
      if (!item.exam) errors.exams[index].exam = "Exam is required";

      if (!item.value) {
        errors.exams[index].value = "Value is required";
      } else {
        if (!validator.isAlphanumeric(item.value.toString())) {
          errors.exams[index].value =
            "Value should contain only numbers and/or letters";
        }
      }
    });
  }

  return errors;
}
